/**
 * マニフェスト管理
 * 最終処分完了報告(最資源化対応)
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/recycle_disposal_reports/primary_manifest_sync_checks`

const manifest_primary_manifest_sync_check = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 2次マニ
     * 処分最終、最終処分終了報告登録前1次マニ反映確認
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.params
     * @property param1.params.manifest_ids { Array } 2次マニのID
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          resolve(data)
        } )
      })
    },

  },
  mutations: {},
}

export default manifest_primary_manifest_sync_check
